<app-project-pagehearder />
@if (bots.length > 0) {
  <div class="bot-toolbar">
    <p-iconfield>
      <p-inputicon class="ri ri-search-line" />
      <input pInputText #filterInput type="text" placeholder="Suche im Archiv..." i18n-placeholder="@@archive-search-placeholder"
        aria-label="Bots suchen" i18n-aria-label="@@bot-table-search" [disabled]="bulkBusy"
        (input)="selectedBots = []; dt.filterGlobal(filterInput.value, 'contains')" />
    </p-iconfield>
  </div>
}
@if (bulkFailedNames) {
  <p class="bot-bulk-error" role="alert"><span i18n="@@bot-bulk-failed">Aktion für folgende Bots fehlgeschlagen:</span> {{bulkFailedNames}}</p>
}
<p-table #dt dataKey="_id" [(selection)]="selectedBots" [value]="bots"
  sortField="updated" [sortOrder]="-1" [rowHover]="true"
  [globalFilterFields]="['name', 'creatorName', 'updator', 'usedIn.botName']"
  [tableStyle]="{ 'table-layout': 'fixed', 'width': '100%', 'min-width': '760px' }">
  <ng-template #header>
    <tr>
      <th class="bot-selection-cell"><p-tableheadercheckbox [disabled]="bulkBusy"
        ariaLabel="Alle angezeigten Bots auswählen" i18n-ariaLabel="@@bot-select-all" /></th>
      <th class="bot-icon-cell"><span i18n="@@bot-table-icon">Icon</span></th>
      <th pSortableColumn="name"><ng-container i18n="@@name">Name</ng-container><p-sorticon field="name" /></th>
      <th pSortableColumn="creatorName"><ng-container i18n="@@owner">Eigentümer</ng-container><p-sorticon field="creatorName" /></th>
      <th pSortableColumn="updated"><ng-container i18n="@@last-change">Aktualisiert</ng-container><p-sorticon field="updated" /></th>
      <th class="bot-menu-cell"></th>
    </tr>
  </ng-template>
  <ng-template #body let-bot>
    <tr>
      <td class="bot-selection-cell"><p-tablecheckbox [value]="bot" [disabled]="bulkBusy"
        [ariaLabel]="bot.name" /></td>
      <td class="bot-icon-cell"><app-bot-icon [botConfig]="bot" /></td>
      <td>
        <div class="bot-status">
          <a class="bot-name" [routerLink]="['/', 'bot-admin', bot._id, botService.getBotDeeplink(bot)]">{{bot.name}}</a>
          @if (bot.isTemplate) { <p-tag icon="ri-layout-5-line" value="Template" i18n-value="@@template" /> }
          <app-admin-position-bubble [position]="bot._id" />
          <app-hint [customIcon]="'ri-lock-fill'" [customColor]="'#666 !important'" i18n="@@bot-no-edit">Du kannst diesen Bot nicht bearbeiten</app-hint>
          @if (bot.quarantine?.isQuarantined) {
            <app-hint [customIcon]="'ri-surgical-mask-line'" [customColor]="'red !important'" i18n="@@bot-quarantine">Bot ist in Quarantäne</app-hint>
          }
        </div>
      </td>
      <td class="bot-metadata">{{bot.creatorName}}</td>
      <td class="bot-metadata">
        @if (bot.updated) {
          <a class="bot-updated" [routerLink]="['/', 'bot-admin', bot._id, 'changelog']"
            [title]="dayjs(bot.updated).format('DD.MM.YYYY HH:mm')">{{dayjs(bot.updated).fromNow()}}</a>
          @if (bot.updator) { <span class="bot-updator">{{bot.updator}}</span> }
        } @else { — }
      </td>
      <td class="bot-menu-cell">
        <p-popover #popover [dismissable]="true" appendTo="body">
          <div class="d-flex flex-column">
            @for (item of contextMenu; track item) {
              <button type="button" class="bot-menu-item" [disabled]="item.disabled || bulkBusy"
                (click)="item.command(); popover.hide()">
                <i [class]="item.icon" class="text-secondary me-3"></i><span>{{item.label}}</span>
              </button>
            }
          </div>
        </p-popover>
        <p-button #btn [disabled]="bulkBusy" (click)="openMenu($event, popover, bot, btn)" rounded severity="secondary"
          icon="ri ri-more-2-fill" styleClass="button-icon" ariaLabel="Bot-Aktionen" i18n-ariaLabel="@@bot-row-actions" />
      </td>
    </tr>
  </ng-template>
<ng-template #emptymessage>
    <tr>
      <td colspan="6" class="text-center p-5 text-muted">
        @if (this.bots.length === 0) {
          <ng-container
            i18n="@@no-bots-in-archive"
            >
          Nichts im Archiv.
        </ng-container>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
<app-bulk-action-bar [actions]="bulkActions" [count]="selectedBots.length" [busy]="bulkBusy"
  [allSelected]="selectedBots.length === (dt.filteredValue ?? bots).length"
  (selectAll)="selectedBots = (dt.filteredValue ?? bots).slice()" (clear)="selectedBots = []" />
